<template>
<vx-card class="mt-5">
    <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6" vs-sm="6" vs-xs="12">
        </vs-col>
        <vs-col class="mb-4" vs-type="grid" vs-justify="right" vs-align="right" vs-w="6" vs-sm="6" vs-xs="12">
            <span class="bg-fondo-1 p-4">
                <h4> {{ institucion.nombreInstitucion }} </h4>
                <p>Provincia: {{ institucion.provincia }} </p>
                <p>Asesor: {{ institucion.asesor }} </p>
            </span>
        </vs-col>
    </vs-row>
    <vs-tabs alignment="fixed">
        <vs-tab label="Docentes">
            <v-docente></v-docente>
        </vs-tab>
        <vs-tab label="Estudiantes">
            <v-estudiante></v-estudiante>
        </vs-tab>
        <!-- <vs-tab label="Información">
            <v-informacion></v-informacion>
        </vs-tab> -->
    </vs-tabs>
</vx-card>
</template>

<script>
// import informacion from './informacion'
import docente from './docente'
import estudiante from './estudiante'
export default {
    components: {
        // 'v-informacion':informacion,
        'v-docente': docente,
        'v-estudiante': estudiante,
    },
    data() {
        return {
            isNavOpen: false,
            institucion: '',
        }
    },
    mounted() {
        this.institucion = JSON.parse(localStorage.institucion);
        this.wasSidebarOpen = this.$store.state.reduceButton
        this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
    },
}
</script>

<style lang="css" scoped>
.bg-fondo-1 {
    background-color: rgba(var(--vs-white1), 1) !important;
    border-radius: 10px;
}
</style>
